<template>
  <span>
    <template v-if="type != undefined && type != 'string' && !isDefault">
      <template v-if="type == 'date'">
          {{ privateValue | date}}
      </template>
      <template v-if="type == 'dateTime'">
        {{ privateValue | date("DD/MM/YYYY")}}
        <br />
        <span style="font-size: 10pt; opacity: 0.75;">
          {{ privateValue | date("HH:mm:ss")}}
        </span>
      </template>
      <template v-if="type == 'hour'">
        {{ privateValue | date("HH:mm:ss")}}
      </template>
      <template v-if="type == 'YesNo'">
        {{ privateValue ? 'Sim' : 'Não'}}
      </template>
      <template v-if="type == 'YesNoIcon'">
        <i :class="privateValue ? 'fas fa-check mr-2' : 'fas fa-times mr-2'" 
           :style="'color: ' + (privateValue ? '#00BB00' : '#BB0000')" />
      </template>
      <template v-if="type == 'currency'">
        {{ privateValue | currency}}
      </template>
      <template v-if="type == 'identity'">
        {{ privateValue | identity}}
      </template>
      <template v-if="type == 'paymentMethodName'">
        {{ privateValue | paymentMethodNameByCode }}
      </template>
      <template v-if="type == 'paymentMethodIcon' && privateValue && privateValue.PaymentMethod">
        <i v-if="privateValue.PaymentMethod.Code != '6'" :alt="privateValue.PaymentMethod | paymentMethodNameByCode" 
          style="font-size: 40px" :class="privateValue.PaymentMethod | paymentMethodIconByCode(privateValue.PaymentObject)" />
        <img v-else alt="Pix" width="40" height="40" src="../../../../assets/images/logo_pix.svg">
      </template>
      <template v-if="type == 'paymentObject' && privateValue && privateValue.PaymentMethod && privateValue.PaymentObject">
        <template v-if="privateValue.PaymentMethod.Code == '1'">
          {{privateValue.PaymentObject.BankSlipNumber}}
        </template>
        <template v-if="privateValue.PaymentMethod.Code == '2'">
          {{privateValue.PaymentObject.InstallmentQuantity}}x {{ privateValue.PaymentObject.IsApplyInterest ? "Com Juros" : "Sem Juros" }}
        </template>
        <template v-if="privateValue.PaymentMethod.Code == '3'">
          {{privateValue.PaymentObject.Amount | currencyCrypto}} {{privateValue.PaymentObject.Symbol}}
        </template>
        <template v-if="privateValue.PaymentMethod.Code == '4'">
          à vista
        </template>
      </template>
      <template v-if="type == 'StatusText'">
        <span class="label rounded" :class="privateValue | StatusColor">{{ privateValue | StatusText }}</span>
      </template>
      <template v-if="type == 'SubscriptionStatusText'">
        <span class="label rounded" :class="privateValue | SubscriptionStatusColor">
          {{ privateValue | SubscriptionStatusText }}
        </span>
      </template>
      <template v-if="type == 'bankImgByCode'">
        <img :src="privateValue" height="32px" width="32px" class="logo"/>
      </template>
      <template v-if="type == 'bankAccountWithLogo'">
        <div v-if="privateValue && privateValue.Bank" class="d-flex align-items-center">
          <img v-if="bankLogoSrc(privateValue.Bank.Code)" :src="bankLogoSrc(privateValue.Bank.Code)" height="28" width="28" class="mr-2" />
          <span>
            <div>Ag: {{ privateValue.BankAgency }}-{{ privateValue.BankAgencyDigit }}</div>
            <div>CC: {{ privateValue.BankAccount }}-{{ privateValue.BankAccountDigit }}</div>
          </span>
        </div>
      </template>
      <template v-if="type == 'entryTypeBadge'">
        <span v-if="privateValue" class="badge" :class="privateValue === 'D' ? 'badge-danger' : 'badge-success'">
          {{ privateValue === 'D' ? 'Débito' : 'Crédito' }}
        </span>
      </template>
      <template v-if="type == 'categoryOrPendingBadge'">
        <span v-if="privateValue">{{ privateValue }}</span>
        <span v-else class="badge badge-warning">Sem categoria</span>
      </template>
      <template v-if="type == 'insertModeBadge'">
        <span v-if="privateValue === 'A'" class="badge badge-info">Automático</span>
        <span v-else-if="privateValue === 'C'" class="badge badge-primary">Manual</span>
        <span v-else-if="privateValue === 'M'" class="badge badge-secondary">Pré-existente</span>
        <span v-else class="badge badge-warning">Não conciliado</span>
      </template>
    </template>
    <template v-else-if="isDefault">
      {{ defaultString }}
    </template>
    <template v-else>
      {{ privateValue }}
    </template>
  </span>
</template>

<script>
export default {
  name: 'Field-Interpolation',
  data() {
    return {
      typesDates: ['date', 'dateTime', 'hour'],
      typesBoolean: ['YesNo', 'YesNoIcon'],
      typesImg: ['bankImgByCode'],
    }
  },
  props: {
    value: {
      require: true
    },
    type: {
      type: String
    },
    defaultString: {
      type: String
    },
  },
  methods: {
    bankLogoSrc: function(code) {
      if (!code) return null;
      try {
        var path = this.$options.filters.bankImgByCode(code);
        if (!path) return null;
        var tempValue = path.split('/assets/');
        tempValue.shift();
        tempValue = tempValue.join('/assets/');
        var format = tempValue.split('.').slice(-1);
        tempValue = tempValue.replace('.' + format, '');
        if (format == 'png') return require("../../../../assets/" + tempValue + ".png");
        if (format == 'jpg') return require("../../../../assets/" + tempValue + ".jpg");
        if (format == 'jpeg') return require("../../../../assets/" + tempValue + ".jpeg");
      } catch (e) {
        return null;
      }
      return null;
    }
  },
  computed:{
    privateValue(){
      if(this.type == 'StatusText'){
        return { TransactionStatus: { Code: this.value } };
      } else if(this.type == 'SubscriptionStatusText'){
        return { SubscriptionStatus: { Code: this.value } };
      } else if(this.typesImg.includes(this.type)){
          if(!this.value){
            throw new TypeError("Valor da imagem não é válido", this.value);
          }else{
            //Imagens dinamicas tem quer um caminho base: https://github.com/webpack/docs/wiki/context#dynamic-require-rewriting
            //E não se pode usar variavel pra armazenar o caminho todo.
            //Se supoe que as imagens vão estar na pasta de assets, pois é necessario um caminho base
            let tempValue = this.$options.filters[this.type](this.value).split('/assets/');
            tempValue.shift();// Remove index 0 do array.
            tempValue = tempValue.join('/assets/');// Caso tenha outra pasta chamada '/assets/' ela volta pro caminho.
            const format = tempValue.split('.').slice(-1);
            // É necessario remover o formato pois ele deve ser passado como texto, se não da erro.
            tempValue = tempValue.replace('.' + format, '');
            if(format == 'png')
              return require("../../../../assets/" + tempValue + ".png");
            else if(format == 'jpg')
              return require("../../../../assets/" + tempValue + ".jpg");
            else if(format == 'jpeg')
              return require("../../../../assets/" + tempValue + ".jpeg");
          }
      } else{
        return this.value;
      }
    },
    isDefault(){
      if(this.defaultString != undefined){
        if(this.typesDates.includes(this.type)){
          return this.privateValue == '0001-01-01T00:00:00' || (new Date(this.privateValue) == 'Invalid Date' && isNaN(new Date(this.privateValue)));
        }else if(this.typesBoolean.includes(this.type)){
          return this.privateValue == null || this.privateValue == undefined;
        }else if(this.type == undefined || this.type == 'string'){
          return this.privateValue == null || this.privateValue == undefined || this.privateValue == "";
        }else{
          return this.privateValue == null || this.privateValue == undefined || this.privateValue == false;
        }
      }else{
        return false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/sub-components/Generic/TableList/FieldInterpolation.vue